/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

/**
 * Created by andrea on 2017-06-19.
 */

export class Competition {

  constructor(public id: string,
              public name: string,
              public logo: string,
              public slogan: string,
              public website: string) {}

  static fromSnapshot(snap: any) : Competition {
    return Competition._fromSnapshot(snap.key, snap.val());
  }

  static fromAngularFireSnapshots(snapshots: any) : Competition[] {
    return snapshots.map(snap => Competition._fromSnapshot(snap.key, snap.payload.val()));
  }

  private static _fromSnapshot(key: string, {logo, name, slogan, website}) {
    return new Competition(key, name, logo, slogan, website);
  }
}



// WEBPACK FOOTER //
// ./src/models/Competition.ts